import { createContext, useContext, useState, useEffect } from "react";

import { authenticate, deauthenticate, adminAccount } from "./authentication.services";

export const AuthenticationContext = createContext();

export const AuthenticationContextProvider = ({ children }) => {

    const [account, setAccount] = useState();
    const [isLoading, setIsLoading] = useState();
    const [token, setToken] = useState();
    const [isAuthenticated, setIsAuthenticated] = useState();

    const signInUser = async (email, password) => {
        try {
            setIsLoading(true);
            const response = await authenticate(email, password);
            const res = await response.json();
            const { token } = res;
            setToken(token);
            localStorage.setItem('acToken', token);
            return res;
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    }

    const signoutUser = async (token) => {
        try {
            setIsLoading(true);
            const response = await deauthenticate(token);
            const res = await response.json();
            return res;
        } catch (error) {
            console.log({error});
        }
    }

    const getMyAccount = async (token) => {
        try {
            const response = await adminAccount(token);
            const res = await response.json();
            return res;
        } catch (error) {
            console.log({ error });
        }
    }

    useEffect(() => {
        (async () => {
            const getAccessToken = new Promise((resolve, reject) => {
                const tk = localStorage.getItem('acToken');
                (tk && tk !== '') ? resolve(tk) : reject(
                 'Invalid access token!'
                )
            });

            try {
                const accessToken = await getAccessToken;
                setToken(accessToken);
                const adminData = await getMyAccount(token);
                if (adminData?.error) {
                    setIsAuthenticated(false);
                    return;
                }else if(adminData?.user){
                    setIsAuthenticated(true);
                }
                setAccount(adminData);
                //console.log(adminData);
            } catch (error) {
                console.log({error})
            }
        })();
        return () => setIsLoading(false);
    }, [token])

    return (
        <AuthenticationContext.Provider
            value={{
                account,
                isLoading,
                token,
                isAuthenticated,
                signInUser,
                adminAccount,
                signoutUser
            }}
        >
            {children}
        </AuthenticationContext.Provider>
    )
}

export const useAuthentication = () => useContext(AuthenticationContext);
